// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const phantump: PokeData = {
  "id": 708,
  "name": "phantump",
  "height": 4,
  "weight": 70,
  "base_experience": 62,
  "types": [
    PokeType.GHOST,
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "leech-seed",
    "growth",
    "confuse-ray",
    "curse",
    "feint-attack",
    "destiny-bond",
    "will-o-wisp",
    "ingrain",
    "astonish",
    "wood-hammer",
    "hex",
    "horn-leech",
    "phantom-force",
    "forests-curse",
    "branch-poke"
  ],
  "moves": [
    "tackle",
    "confuse-ray",
    "curse",
    "wood-hammer",
    "phantom-force",
    "branch-poke",
    "leaf-tornado",
    "flower-rush",
    "night-shade",
    "poltergeist",
    "grassy-terrain",
    "soul-sacrifice",
    "spectral-snatch"
  ],
  "evolution_chain": {
    "id": 364,
    "item": null,
    "species": [
      {
        "name": "phantump",
        "order": 708,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "trevenant",
        "order": 709,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 708,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 48.5,
    "speed": 38,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
